import { useMemo } from "react";
import { useStructureContext } from "../../../context/StructureContext";
import { stdObject } from "../../../data/types/stdObject";
import { headerUsers } from "../../../data/admin";
import StdTable from "./StdTable";
import { useSelector } from "react-redux";
import { RootState } from "../../../store/store";
import { objectToArray } from "../../../utils/objectToArray";
import { useMainContext } from "../../../context/MainContext";

export default function UsersBox() {
  const usersListData: stdObject = useSelector(
    (state: RootState) => state.data.usersList,
  );
  const usersList: Array<stdObject> = useMemo(
    () =>
      objectToArray("CODUSU", usersListData).sort(
        (a: stdObject, b: stdObject) => a.NOMUSU.localeCompare(b.NOMUSU),
      ),
    [usersListData],
  );
  const userAccess: stdObject = useSelector(
    (state: RootState) => state.data.userAccess,
  );
  const { type, searchValues, section } = useStructureContext();
  const { openUserInfo, createUserToken } = useMainContext();

  return "ROLUSU" in searchValues[section.id] ? (
    <div className="listBox">
      <StdTable
        type={type}
        style={{ width: "100%" }}
        header={(userAccess.Z.Z2 === 2
          ? headerUsers
          : headerUsers.filter((e: stdObject) => e.type !== "reset")
        ).map((e: stdObject) => {
          return { ...e, reset: createUserToken };
        })}
        data={
          searchValues[section.id].ROLUSU.value === ""
            ? usersList
            : usersList.filter(
                (e: stdObject) =>
                  e.ROLUSU === Number(searchValues[section.id].ROLUSU.value),
              )
        }
        onDoubleClick={openUserInfo}
        className="listTableRow"
      />
    </div>
  ) : (
    <></>
  );
}
